import {Component} from "react";
import * as React from "react";
import {imageUrl,isMobile} from "../../helpers/ApplicationHelper";

class AccordionBox extends Component {
    verificationTimeout = null

    constructor(props) {
        super(props)
        this.state = {
            style:{},
            animateStep:false,
            addClass:""
        }

        // If a box is supposed to be open on initial display - we need to do the following
        if ( props.isOpen ) {
            this.state.maxHeight = "none"
            this.state.showChildren = true
        }

        this.boxClicked = this.boxClicked.bind(this)
        this.handleAnimation = this.handleAnimation.bind(this)
        this.setFullHeight = this.setFullHeight.bind(this)
    }

    componentDidMount() {
        // for boxes that are open on construction.
        if ( this.props.isOpen ) {
            setTimeout((() => {
                this.setState({addClass:" margin-transition "})
                this.setFullHeight()
            }).bind(this),200)
        }
    }

    componentWillUnmount() {
        this.clearVerificationTimeout()
    }

    clearVerificationTimeout() {
        if ( this.verificationTimeout ) {
            clearTimeout(this.verificationTimeout)
            this.verificationTimeout = null
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // did the open state change for this box?
        if ( prevProps.isOpen !== this.props.isOpen ) {
            // if so - set the state to animate step so we can perform
            this.setState({
                animateStep:!isMobile(),    // no need for animate step on mobile.
                maxHeight: 45,
                showChildren:true
            })

            if ( this.props.isOpen ) {
                this.verificationTimeout = setTimeout(this.setFullHeight,200) // in some performance cases the transition end event is missed.
                                                        // add this on timeout to cover these edge cases.
            }
        }
        // using an 'other' field can cause a height change.
        // on mobile - we always want to adjust height immediately.
        if ( (isMobile() || prevProps.value !== this.props.value) &&
            this.mainDiv.scrollHeight > this.state.maxHeight && this.props.isOpen ) {
            this.setFullHeight()
        }
    }


    boxClicked() {
        this.clearVerificationTimeout()
        this.props.toggleBox(this.props.name)
    }

    drawv() {
        return <span><img style={{marginRight:"5px"}} src={imageUrl("v.svg")} /> </span>
    }

    render() {
        return <div className={"accordion-box " + this.state.addClass + (this.props.isOpen ? "open" : "") + (this.state.animateStep ? " animateStep" : "")}
                    style={{
                        maxHeight:isNaN(this.state.maxHeight) ? this.state.maxHeight : this.state.maxHeight+"px",
                        minHeight:isNaN(this.state.maxHeight) ? this.state.maxHeight : this.state.maxHeight+"px",
                    }}
                    data-automation={this.props.name}
                    onTransitionEnd={this.handleAnimation}
                    ref={(ref) => {this.mainDiv = ref}}>
            {/* the header-clicker below - for a large click area for toggling the box */}
            <div className={"accordion-box-header-clicker"} onClick={this.boxClicked}></div>
            <div className={"accordion-box-header" + (this.props.errorField ? " field-error" : "") } >
                <div className={"accordion-box-header-arrow"}></div>
                {this.props.value && this.props.value.length ? this.drawv() : "" }
                {this.props.label + (this.props.value && this.props.value.length ? (this.props.label.endsWith("?") ? " " : ": ")+this.props.value : "")}
            </div>
            {this.state.showChildren ? <div style={{padding:"11px 0px",boxSizing:"border-box"}}>   {{
              ...this.props.children,
              props: {
                ...this.props.children.props,
                setFullHeight: this.setFullHeight,
              },
            }}</div> : null}
            { this.state.showChildren && this.props.note ? <div className={'boxed-note'} dangerouslySetInnerHTML={ {__html: this.props.note}}></div> : null }
        </div>
    }

    setFullHeight() {
        this.setState({maxHeight:this.mainDiv.scrollHeight + 2, animateStep: false})
        this.clearVerificationTimeout()
    }

    handleAnimation(animated) {
        // handle open animation
        if ( this.props.isOpen ) {
            // when opening - width needs to finish b
            if ( animated.propertyName === "width" ) {
                this.setFullHeight()
            }
        } else {
            if ( animated.propertyName === "max-height") {
                this.setState({
                    animateStep:false,
                })
                // on mobile ios, the children disappear before the height transition actually ends for some reason.
                setTimeout((() => {
                    // make sure it's still closed after the timeout.
                    this.props.isOpen ? null : this.setState({showChildren:false})
                }).bind(this),250)
            }
        }
    }
}

export {AccordionBox}